<template>
  <div class="register-page">
    <b-modal
      centered
      ref="dialogWait"
      no-close-on-backdrop
      no-close-on-esc
      size="sm"
      hide-header
      hide-footer
    >
      <div class="center-xs">
        <spinner />
      </div>
      <div class="center-xs pt-3">
        {{currentLoadingMessage}}
      </div>
    </b-modal>
    <div :class="computedClass">
      <div class="page-title col-xs-12 col-sm-6 pt-2">
        Manejo {{ tab }} /
        {{ currentTab.is_table ? "Dados Opcionais" : `(${list.length})` }}
      </div>
    </div>

    <div
      class="
        m-0
        align-items-center
        container-dropdown
        row
        w-100
        d-flex
        justify-content-around
      "
    >
      <div class="around-xs w-50">
        <b-dropdown
          :text="currentTab.name.toUpperCase()"
          class="w-100 pr-2"
          :variant="'3v3'"
          :disabled="showErrorNotSearch"
          size="sm"
        >
          <b-dropdown-item
            v-for="(e, index) in routes"
            :key="e.type"
            @click="currentTabIndex = index"
          >
            {{ e.name }}
          </b-dropdown-item>
        </b-dropdown>
      </div>
      <toolbar
        :hide-register="currentTab.type == 'external_infos'"
        class="w-50 pl-2"
        :type="type"
        :is-mobile="ismob"
        :is-searching="isSearching"
        @search="searchBy"
        @clear-search="clearSearch"
        @edit="edit"
        @remove="removeDialog()"
        @add="add"
        :is-admin="isAdmin"
        :selected="selected"
        :number-of-elements="list.length"
        :type-filtering="''"
        :not-exists="showErrorNotFound"
        :not-search="showErrorNotSearch"
        ref="INP"
        :is-show="loading"
      />
    </div>

    <div class="register-main">
      <div class="list-items row">
        <div v-if="loading" class="col-xs-12 center-xs">
          <spinner /> Aguarde...
        </div>

        <div
          v-if="showErrorNotFound && !['external_infos', 'configs'].includes(this.currentTab.type)"
          class="
            EmptyRequest
            w-100
            h-100
            p-0
            row
            center-xs center-md center-sm center-xs0
            mt-3
          "
        >
          <img :src="emptyIcon" class="empty" />
          <span>Não há manejo para exibir.</span>
        </div>
        <div
          v-if="showErrorNotSearch && !showErrorNotFound"
          class="EmptyRequest row center-xs mx-2 md-12 w-100 p-0 mt-3"
          style="text-align: left"
        >
          <img :src="searchIcon" class="empty" />
          <span>
            Nenhum resultado encontrado. Para voltar a exibir todos os manejos
            <b-link @click="clearSearch"> clique aqui </b-link>.</span
          >
        </div>

        <div v-if="list && list.length" class="w-100 row">
          <div
            v-for="(item, index) in list"
            v-show="!loading"
            :key="index"
            class="col-xs-12 col-sm-4 col-md-3"
          >
            <div class="item-card eqp-card">
              <div class="header-card">
                <div class="card-name">
                  <div
                    class="container-card-header d-flex justify-content-between"
                  >
                    <div class="header-title">{{ item.NAME }}</div>
                    <div class="show-details-cards pb-2">
                      <b-link
                        v-if="showDetailsLink(item)"
                        @click="showDetails(item)"
                      >
                        Abrir planilha
                      </b-link>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-details">
                <div v-if="currentTab.type === 'soil'">
                  <div v-if="item.DENSITY">
                    <strong>Densidade Aparente (g/cm³) :</strong>
                    {{ item.DENSITY }}
                  </div>
                  <div v-if="item.FIELD_CAPACITY">
                    <strong>Capacidade de Campo : </strong>
                    {{ formatToPercentage(item.FIELD_CAPACITY,2,0) }}
                  </div>
                  <div v-if="item.TRANSMISSIVITY">
                    <strong>Transmissividade do Solo: </strong>
                    {{ item.TRANSMISSIVITY }}
                  </div>
                  <div v-if="item.WILT_POINT">
                    <strong>Ponto de Murcha Permanente : </strong>
                    {{ formatToPercentage(item.WILT_POINT,2,0) }}
                  </div>
                </div>
                <div v-if="currentTab.type === 'farm'">
                  <div class="slider">
                    <strong>Lâmina de Transplantio (mm) : </strong
                    >{{ item.LAMINA }}
                  </div>
                </div>
                <div v-if="currentTab.type === 'fertilizer'">
                  <div v-if="item.DILUTION >= 0">
                    <strong>Diluição :</strong> {{ item.DILUTION }}
                  </div>
                  <div>
                    <strong>É especial? </strong>
                    {{ item.isEspecial ? "sim" : "não" }}
                  </div>
                </div>
                <div>
                  <!-- <br /> -->
                </div>
                <div v-if="item.NOTE">
                  <strong>Observação:</strong> {{ item.NOTE }}
                </div>
              </div>
              <div class="footer">
                <b-checkbox
                  class="checkbox last-update"
                  v-show="isAdmin"
                  :value="item"
                  v-model="selected"
                />

                <div>
                  <label
                    :for="`checkbox${item.NAME}`"
                    class="details-btn last-update"
                  >
                    Editado em {{ formatFullDateTime(item.UPDATE) }}
                  </label>
                  <edited-agn-icon
                    v-if="item.EDITOR_NAME"
                    :alt="`Último editor: ${item.EDITOR_NAME}`"
                    title=""
                    class="action-icon-right details-btn"
                    :id="`editor${item.NAME}`"
                  />
                </div>
                <b-tooltip
                  :ref="`editor${item.NAME}`"
                  :target="`editor${item.NAME}`"
                  placement="topleft"
                >
                  Último editor: {{ item.EDITOR_NAME }}
                </b-tooltip>
              </div>
            </div>
          </div>
        </div>
        <!-- <external-infos-table
          v-show="!loading"
          :has-station="hasStation"
          @loading="(val) => (loading = val)"
          v-if="currentTab.type == 'external_infos'"
          class="col-xs-12"
        /> -->
        <InitialManagementHour
          v-else-if="currentTab.type == 'configs'"
          v-model="startHour"
          must-save-on-change
          class="col-xs-6 mt-3"
        />

      </div>
      <!-- END REGISTER MAIN -->
    </div>

    <!-- MODAL DE REMOÇÃO DE EQUIPAMENTOS -->
    <b-modal
      ref="removeItem"
      centered
      size="sm"
      ok-title="Deletar"
      ok-variant="danger"
      @ok="confirmRemove"
      cancel-title="Cancelar"
      content-class="shadow"
      cancel-variant="outline-secondary"
      title="Atenção!"
    >
      <div class="modal-form">
        <div class="title-modal-info">
          {{
            selected.length == 1
              ? "1 item será apagado"
              : selected.length + " itens serão apagados"
          }}.
        </div>
      </div>
    </b-modal>

    <b-modal
      ref="notRemovedItem"
      centered
      size="sm"
      ok-title="Estou ciente"
      ok-variant="danger"
      @ok="closeItemsWithSectorsModal"
      ok-only
      title="Atenção!"
    >
      <div class="modal-form">
        <div class="title-modal-info">
          Não foi possível deletar os items pois estão atrelados ao setor:
          <ul>
            <li v-for="(item, i) of itemsWithSectors" :key="i">
              {{ item.NAME }}
            </li>
          </ul>
        </div>
      </div>
    </b-modal>

    <!-- MODAL DE EXIBIÇÃO DA PLANILHA -->
    <b-modal
      ref="sheetModal"
      :title="modalTitle"
      centered
      hide-footer
      scrollable
      size="farm"
      content-class="shadow"
      no-close-on-backdrop
      no-close-on-esc
      header-bg-variant="3v3"
      header-text-variant="light"
      @close="closeFarmsTable"
    >
      <FarmsTable
        ref="farmsTable"
        @table-saved="cancelTable"
        :id-farm="id_farm"
        :title="modalTitle"
        :editor-name="editor_name"
        :last-update="last_update"
      />
    </b-modal>

    <b-modal
      ref="saveTableConfirmModal"
      centered
      no-close-on-backdrop
      size="sm"
      ok-title="Sim"
      cancel-title="Não"
      @cancel="cancelTable"
      @ok="saveTableAndCloseModal"
      ok-variant="success"
      title="Atenção!"
    >
      <div class="modal-form">
        <div class="title-modal-info">
          Deseja salvar as alterações feitas na tabela de cultivar?
        </div>
      </div>
    </b-modal>

    <soil-form
      v-if="currentTab.type == 'soil'"
      :show-form="showForm"
      :form-type="formType"
      :item="selectedItem"
      :old-name="formType == 'edit' && selected.length ? selected[0].NAME : ''"
      :item-to-edit="selected.length && selected[0]"
      :already-used-names="fullList.length && fullList.map((e) => e.NAME)"
      @submit="submit"
      @close-form="closeForm"
    />

    <farm-form
      v-else-if="currentTab.type == 'farm'"
      :show-form="showForm"
      :form-type="formType"
      :item="selectedItem"
      :old-name="formType == 'edit' && selected.length ? selected[0].NAME : ''"
      :item-to-edit="selected.length && selected[0]"
      :already-used-names="fullList.length && fullList.map((e) => e.NAME)"
      @submit="submit"
      @close-form="closeForm"
    />

    <fertilizer-form
      v-else-if="currentTab.type == 'fertilizer' && showForm"
      :show-form="showForm"
      :form-type="formType"
      :item="selectedItem"
      :old-name="formType == 'edit' && selected.length ? selected[0].NAME : ''"
      :item-to-edit="selected.length && selected[0]"
      :already-used-names="fullList.length && fullList.map((e) => e.NAME)"
      @submit="submit"
      @close-form="closeForm"
    />
  </div>
</template>

<script>

import { cookies } from "@/pages/components/cookies";
import { formatToPercentage } from "@/pages/components/helpers.js";
import FarmsTable from "./components/FarmsTable.vue";
import managementSectorsActions from "@/mixins/managementSectorActions.js";
import moment from "moment";
import InitialManagementHour from "@/common/components/InitialManagementHour/SelectHour.vue"

//MANAGEMENT API
import { farmUseCase } from "../../../api/modules/farm/useCases";
import { soilUseCase } from "../../../api/modules/soil/useCases";
import { fertilizerService } from "../../../api/modules/fertilizer/useCases";
import { checkIfFarmDapExists } from "../../../api/modules/farms_dap/useCases/checkIfExistsFarmDap";
import { monit } from "@/api";
import { isDevelopment } from "@/helpers/development";

export default {
  name: "management",
  props: {
    local: [String],
    mobile: Boolean,
    managementAccess: Boolean,
  },
  mixins: [managementSectorsActions],
  components: {
    InitialManagementHour,
    FarmsTable,
    // ExternalInfosTable,
  },
  async created() {
    this.$emit("title-change", "Manejo");
    this.isAdmin = Number(cookies.get("PERMISSION")) == 1;
    if (this.managementAccess) this.isActive();

    // this.routes = this.routes.filter((route) => !route.without_station);
  },
  data() {
    return {
      startHour: 0,
      isAdmin: false,
      showConfigs: false,
      hasStation: true,
      title: "",
      currentLoadingMessage: "",
      loadingRecalc: false,
      showForm: false,
      type: "",
      currentTabIndex: 0,
      loading: true,
      errorMsg: "Ocorreu um erro. Recarregue a página e tente novamente.",
      ismob: false,
      emptyIcon: require("../../../assets/icons/Empty.svg"),
      searchIcon: require("../../../assets/icons/search.svg"),
      tab: "",
      list: [],
      fullList: [],
      itemsWithSectors: [],
      isSearching: false,
      filter: "",
      selected: [],
      allSelected: false,
      formType: null,
      alreadyNames: [],
      detailsName: "",
      id_farm: null,
      editor_name: null,
      last_update: null,
      details: [],
      //Render list
      soilList: [],
      fertilizerList: [],
      farmList: [],
      //
      showErrorNotFound: false,
      showErrorNotSearch: false,
    };
  },
  watch: {
    loadingRecalc: {
      handler(newValue) {
        if(newValue) {
          this.$refs.dialogWait.show()
        } else {
          this.$refs.dialogWait.hide()
        }
      }
    },
    currentTabIndex() {
      this.loading = true;
      this.isActive();
    },
  },
  computed: {
    routes() {
      return [
        {
          type: "soil",
          name: "SOLOS",
        },
        {
          type: "configs",
          name: "Configurações",
        },
        {
          type: "farm",
          name: "CULTIVARES",
        },
        {
          type: "external_infos",
          name: "ESTAÇÃO",
          is_table: true,
          without_station: true,
        },
        {
          type: "sectors",
          name: "SETORES",
        },
      ].filter(route => (!this.hasStation || this.isDev) ? true : !route.without_station)
      .map(opt => {
        opt.name = opt.name.toUpperCase();

        return opt;
      })
    },
    isDev() {
      return isDevelopment();
    },
    currentTab() {
      return this.currentTabIndex
        ? this.routes[this.currentTabIndex]
        : this.routes[0];
    },
    modalTitle() {
      return `${
        this.currentTab.type.indexOf("farm") > -1 ? "Cultivar" : "####"
      } ${this.detailsName} ${this.id_farm}`;
    },
    computedClass() {
      this.ismob = this.mobile;
      let className = "row align-items-center header";
      if (this.mobile) {
        className = "row align-items-center header-mobile";
        return className;
      }
      return className;
    },
    validFilter() {
      return !!this.filter.split(" ").join("");
    },
    //título do modal de adição
    selectedItem() {
      if (this.currentTab.type == "soil") return "solo";
      else if (this.currentTab.type == "farm") return "cultivares";
      else if (this.currentTab.type == "configs") return "configuracoes";
      else if (this.currentTab.type == "fertilizer") return "adubo";
    },
    removeMsg() {
      let msg = "";
      if (this.currentTab.type == "hydros")
        return "Caso haja associações deste hidrômetro com válvulas e setores essas associações também serão deletadas.";
      else if (this.currentTab.type == "sensors")
        return "Caso haja associações deste sensor com setores, estas associações também serão deletadas.";
      else return "";
    },
  },
  methods: {
    formatToPercentage,
    async generateManagement() {
      try {
        const idSoil = this.selected && this.selected[0] && this.selected[0].ID;

        if(!idSoil) {
          return;
        }

        this.loadingRecalc = true;
        this.currentLoadingMessage = "Procurando setores atrelados a este solo...";
        const managementSectors = await this.getManagementSectors({ID_SOIL: idSoil});

        if(managementSectors && managementSectors.length) {
          this.currentLoadingMessage = "Recalculando setores dependentes deste solo...";
          await this.recalcSectorsManagement(managementSectors);
        }

        this.loadingRecalc = false;
        alert("Sucesso ao realizar calculo de manejo", "s");

      } catch(e) {
        this.loadingRecalc = false;
        alert("Erro ao realizar calculo de manejo", "e");
        console.log(e);

      }
    },
    cancelTable() {
      this.$refs.saveTableConfirmModal.hide();
      this.$refs.sheetModal.hide();
    },
    saveTableAndCloseModal() {
      this.$refs.farmsTable.saveTableAndCloseModal();
    },
    closeFarmsTable(e) {
      if(this.$refs.farmsTable.changedTableData) {
        e.preventDefault();
        this.$refs.saveTableConfirmModal.show();
      }
    },
    formatFullDateTime(date) {
      return moment(date).format("DD/MM/YYYY HH:mm:ss");
    },
    //referente à sinalização na aba de Equipamentos
    //também faz a troca dos itens para disposição na tela
    isActive() {
      this.list = [];
      this.isSearching = false;
      this.loading = true;
      this.filter = "";
      this.showConfigs = false;

      if (this.currentTab.type == "farm") {
        this.selected = [];
        // farmService.show
        farmUseCase()
          .show.execute()
          .then((resp) => {
            this.list = resp[0] || [];
            this.fullList = this.list.map((e) => e);
          })
          .catch((err) => {
            console.error(err);
          })
          .then((_) => {
            this.loading = false;
            if (
              !this.list.length &&
              this.showErrorNotSearch === false &&
              !this.loading
            ) {
              this.showErrorNotFound = true;
            } else {
              this.showErrorNotFound = false;
            }
          });
      } else if (this.currentTab.type == "soil") {
        this.selected = [];
        // soilService.show
        soilUseCase()
          .show.execute()
          .then((resp) => {
            this.list = resp[0] || [];
            this.fullList = this.list.map((e) => e);
          })
          .catch((err) => {
            console.error(err);
          })
          .then((_) => {
            this.loading = false;
            if (
              !this.list.length &&
              this.showErrorNotSearch === false &&
              !this.loading
            ) {
              this.showErrorNotFound = true;
            } else {
              this.showErrorNotFound = false;
            }
          });
      } else if (this.currentTab.type == "configs") {
        this.showConfigs = true;
        this.loading = false;

      } else if (this.currentTab.type == "fertilizer") {
        this.selected = [];
        fertilizerService.show
          .execute()
          .then((resp) => {
            this.list = resp[0] || [];
            this.fullList = this.list.map((e) => e);
          })
          .catch((err) => {
            console.error(err);
          })
          .then((_) => {
            this.loading = false;
            if (
              !this.list.length &&
              this.showErrorNotSearch === false &&
              !this.loading
            ) {
              this.showErrorNotFound = true;
            } else {
              this.showErrorNotFound = false;
            }
          });
      } else if (this.currentTab.type == "external_infos") {
        this.loading = false;
      } else if (this.currentTab.type == "sectors") {
        this.$router.push({ name: "register_sectors" });
      }
    },
    //exibir botão para abrir planilha quando for cultivar
    showDetailsLink() {
      return ["farm"].includes(this.currentTab.type);
      // && (item.RANGE || item.MEASURES || item.FK_SENSOR)
    },
    closeForm() {
      this.showForm = false;
      this.formType = "";
    },
    showDetails(item) {
      this.detailsName = item.NAME;
      this.id_farm = item.ID;
      this.editor_name = item.EDITOR_NAME
      this.last_update = item.UPDATE
      this.details = [item];
      this.$refs.sheetModal.show();
    },
    detailsFields() {},
    //checkboxes
    toggleAll() {
      this.allSelected = !this.allSelected;
      if (this.selected.length < this.list.length)
        this.selected = this.list.slice();
      else if (this.selected.length == this.list.length) this.selected = [];
    },
    //excluir itens da lista de selecionados
    makeAlert(ret) {
      if (ret) alert(ret.log, ret.alert);
      else alert(this.errorMsg);
    },
    removeDialog() {
      this.$refs.removeItem.show();
    },
    closeItemsWithSectorsModal() {
      this.isActive();
      this.selected = [];
      this.itemsWithSectors = [];
    },
    async deleteSoil(soils) {
      for await (let item of soils) {
        let resp = await soilUseCase().del.execute(item.ID);
        //resp[0] === [] => deu algum erro no delete
        if (!resp[0]) {
          this.makeAlert({
            alert: "e",
            log: `Falha ao deletar Solo ${item.NAME}`,
          });
        } else {
          this.makeAlert({
            alert: "s",
            log: `Sucesso ao deletar Solo ${item.NAME}`,
          });
        }
      }
    },
    async deleteFarm(farms) {
      for (let item of farms) {
        let hasFarmDap = await checkIfFarmDapExists.execute(item.ID);
        if (hasFarmDap) {
          alert(
            `Não foi possível deletar o cultivar ${item.NAME} pois possui dados de DAP`,
            "e"
          );
          continue;
        }
        let resp = await farmUseCase().del.execute(item.ID);
        //resp[0] === [] => deu algum erro no delete
        if (!resp[0]) {
          this.makeAlert({
            alert: "e",
            log: `Falha ao deletar cultivar ${item.NAME}`,
          });
        } else {
          this.makeAlert({
            alert: "s",
            log: `Sucesso ao deletar cultivar ${item.NAME}`,
          });
        }
      }
    },
    async confirmRemove() {
      //Solo
      let IDs = this.selected.map((item) => item.ID);
      if (this.currentTab.type == "soil") {
        //Buscar no banco por esses IDs para saber quais não irá conseguir apagar
        const soilsWithSectors = await soilUseCase().getSectorsWithSoil.execute(
          IDs
        );
        //Não tiver solos atrelado ao setor
        if (!soilsWithSectors.length) {
          try {
            await this.deleteSoil(this.selected);
            this.isActive();
            this.selected = [];
          } catch (error) {
            console.error("[DELETE - SOIL] ", err);
            alert("Ocorreu um erro ao realizar a operação. Tente novamente.");
            this.selected = [];
          }

          return;
        }
        //Filtragem só por solos que irão serem apagados
        let soils = this.selected.filter(
          (item) => !soilsWithSectors.some((soil) => soil.ID_SOIL == item.ID)
        );
        await this.deleteSoil(soils);
        this.itemsWithSectors = soilsWithSectors;
        this.$refs.notRemovedItem.show();
        //Emitir um alerta que está atrelado ao setor
      }
      // Adubo
      else if (this.currentTab.type == "fertilizer") {
        this.selected.map((item) => {
          fertilizerService.del
            .execute(item.ID)
            .then((resp) => {
              /*
                resp[0] === [] => deu algum erro no delete
              */
              if (!resp[0]) {
                this.makeAlert({
                  alert: "e",
                  log: "Falha ao deletar Adubo",
                });
              } else {
                this.makeAlert({
                  alert: "s",
                  log: "Sucesso ao deletar Adubo",
                });
                this.isActive();
                this.selected = [];
              }
            })
            .catch((err) => {
              console.error("[DELETE - FERTILIZER] ", err);
              alert("Ocorreu um erro ao realizar a operação. Tente novamente.");
              this.selected = [];
            });
        });
      }
      //Cultivar
      else if (this.currentTab.type == "farm") {
        const farmsWithSectors = await farmUseCase().getSectorsWithFarm.execute(
          IDs
        );

        if (!farmsWithSectors.length) {
          try {
            await this.deleteFarm(this.selected);
            this.isActive();
            this.selected = [];
          } catch (error) {
            console.error("[DELETE - FARM] ", err);
            alert("Ocorreu um erro ao realizar a operação. Tente novamente.");
            this.selected = [];
          }

          return;
        }

        let farms = this.selected.filter(
          (item) => !farmsWithSectors.some((farm) => farm.ID_FARM == item.ID)
        );

        await this.deleteFarm(farms);
        this.itemsWithSectors = farmsWithSectors;
        this.$refs.notRemovedItem.show();
      }
      // this.$refs.removeEqp.hide();
    },
    //pré-definição dos campos na área de edição
    edit() {
      this.formType = "edit";
      this.showForm = true;
    },
    async updateSoilEditor(data) {
      if (this.formType === "add") {
        const soilId = await soilUseCase().getSoilIdByName.execute(data.NAME);
        await soilUseCase().updateFkEditor.execute(soilId, data.FK_EDITOR);
      } else {
        await soilUseCase().updateFkEditor.execute(data.ID, data.FK_EDITOR);
      }
    },
    async updateFarmEditor(data) {
      if (this.formType === "add") {
        const farmID = await farmUseCase().getFarmIdByName.execute(data.NAME);
        await farmUseCase().updateFkEditor.execute(farmID, data.FK_EDITOR);
      } else {
        await farmUseCase().updateFkEditor.execute(data.ID, data.FK_EDITOR);
      }
    },
    async submit(data) {
      //Solo

      if (this.currentTab.type == "soil") {
        // soilService[this.formType]
        await soilUseCase()
          [this.formType].execute(data)
          .then(async (resp) => {
            // resp[0] == [] => erro na inserção
            if (!resp[0]) {
              this.makeAlert({
                alert: "e",
                log: "Erro ao tentar inserir dados do solo",
              });
            } else {
              await this.generateManagement();

              this.makeAlert({
                alert: "s",
                log: "Cadastro de solo realizado com sucesso",
              });

              await this.updateSoilEditor(data);

              this.isActive();
            }
          })
          .catch((err) => {
            console.error("[SUBMIT SOIL] - ", err);
            this.makeAlert({
              alert: "e",
              log: err,
            });
          });

        this.closeForm();
      }
      // Adubo
      else if (this.currentTab.type == "fertilizer") {
        fertilizerService[this.formType]
          .execute(data)
          .then((resp) => {
            // resp[0] == [] => erro na inserção
            if (!resp[0]) {
              this.makeAlert({
                alert: "e",
                log: "Erro ao tentar inserir dados do cultivar",
              });
            } else {
              this.makeAlert({
                alert: "s",
                log: "Cadastro de cultivar realizado com sucesso",
              });
              this.isActive();
            }
          })
          .catch((err) => {
            console.error("[SUBMIT FARM] - ", err);
            this.makeAlert({
              alert: "e",
              log: err,
            });
          });
      }
      //Cultivar
      else if (this.currentTab.type == "farm") {
        // farmService[this.formType]
        farmUseCase()
          [this.formType].execute(data)
          .then(async (resp) => {
            // resp[0] == [] => erro na inserção
            if (!resp[0]) {
              this.makeAlert({
                alert: "e",
                log: "Erro ao tentar inserir dados do cultivar",
              });
            } else {
              this.makeAlert({
                alert: "s",
                log: "Cadastro de cultivar realizado com sucesso",
              });

              await this.updateFarmEditor(data)

              this.isActive();
            }
          })
          .catch((err) => {
            console.error("[SUBMIT FARM] - ", err);
            this.makeAlert({
              alert: "e",
              log: err,
            });
          });
      }
    },
    //adicionar um novo equipamento ao sistema
    add() {
      this.formType = "add";
      this.showForm = true;
    },
    searchBy(name) {
      this.selected = [];
      this.isSearching = !!name.split(" ").join("");
      this.filter = name.toUpperCase();
      if (this.isSearching && this.validFilter && this.fullList.length) {
        this.list = this.fullList.filter((item) => {
          // Lógica para filtrar
        });
        if (this.list.length) {
          this.showErrorNotSearch = false;
        } else {
          this.showErrorNotSearch = true;
        }
      } else {
        this.list = this.fullList.map((e) => e);
      }
    },
    clearSearch() {
      this.selected = [];
      this.isSearching = false;
      this.showErrorNotSearch = false;
      this.list = this.fullList.map((e) => e);
      this.$refs.INP.clearText();
    },
  },
};
</script>

<style scoped>
p {
  margin-bottom: 5px;
}
.card-name {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.card-name .material-design-icon {
  font-size: 1.3em;
  color: var(--green-3v3);
  align-self: flex-start;
}
.eqp-card {
  padding-bottom: 55px !important;
  max-height: 235px;
  min-height: 230px;
}
.header-maker,
.header-model {
  color: #e07f52;
  font-size: 0.88em;
}
.container-card-header {
  width: 100%;
}
.header-title {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: calc(100% - 30px);
  /* max-width: 177px; */
}
h5 {
  word-break: break-all;
  color: var(--text-gray-primary);
  font-weight: 600;
}
.card-details {
  padding-top: 3px;
  height: 143px;
  overflow-y: auto;
  font-size: 0.86em;
  color: var(--text-gray-primary);
  text-overflow: ellipsis;
  line-height: 1.4em;
}
.card-details strong {
  color: var(--text-gray-primary);
}
.scrollable {
  max-height: 400px;
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 2px;
}
.header {
  flex-basis: 34px;
}

.last-update {
  font-size: 0.7em !important;
  margin-left: 0 !important;
  margin-right: 6px !important;
  cursor: default !important;
  color: var(--text-gray-primary);
}

.eqp-card .material-design-icon{
  vertical-align: -2px;
  margin: 0;
  color: #929292;
  font-size: 1.3em;
}
.show-details-cards a {
  padding: 3px 6px;
  border-radius: 5px;
  min-height: 1.5em;
  border: 1px solid #bebebe;
  font-weight: 500;
  font-size: 0.7em;
  color: #a1a1a1;
  transition: all 0.4s ease;
}
.show-details-cards a:hover {
  background: #f5f5f5;
}
.register-page-warning {
  overflow-y: auto;
  overflow-x: hidden;
  height: 95.8%;
}
.footer {
  height: 35px;
  padding: 0 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.header-mobile {
  min-height: 29px;
}
@media screen and (max-width: 767px) {
  .header-card {
    min-height: 40px;
    overflow: hidden;
    text-overflow: ellipsis;
    border-bottom: 1px solid #ececec;
  }

  .header {
    min-height: 90px;
  }
}

@media screen and (max-width: 676px) {
  .eqp-card {
    padding-bottom: 45px !important;
  }
}
</style>
